import BenchlingConfig from 'BenchlingConfig';
import {SystemColumnName} from 'data-frames/DataFrameConstants';
import {DataType} from 'data-frames/DataFrameTypes';
import {RESTOutlierConfig} from 'insights/analytics-visualizations/RESTAnalyticsVisualizationTypes';
import * as TaskRunner from 'util/TaskRunner';
import withPromisePool from 'util/withPromisePool';

import {LogisticRegressionResults} from './LogisticRegression';
import {RegressionConfig} from './RegressionTypes';

export interface LogisticCurveFitData {
  dataframe: {
    points: Array<{[SystemColumnName.ROW_ID]: unknown; x: unknown; y: unknown}>;
    dataTypes: {[SystemColumnName.ROW_ID]: DataType.STRING; x: DataType.NUMBER; y: DataType.NUMBER};
  };
  fitFunctionToColumnMap: {
    rowIds: SystemColumnName.ROW_ID;
    xValues: 'x';
    yValues: 'y';
  };
  outlierConfig: RESTOutlierConfig | null;
  regressionConfig: RegressionConfig;
}

function _runLogisticRegression(data: LogisticCurveFitData): Promise<LogisticRegressionResults> {
  return TaskRunner.postJSONPromise({
    url: '/1/api/insights/statistics:run-hill-curve-fit',
    data,
  });
}

export const runLogisticRegression = withPromisePool(
  _runLogisticRegression,
  BenchlingConfig.INSIGHTS_MAX_CONCURRENT_REGRESSIONS_PER_BROWSER_TAB
);
